import { getListBobotKomponenPenilaian } from "@/services/getData"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { useQuery } from "@tanstack/react-query"

export default function MasterBobotKomponenPenilaianPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listBobotKomponenPenilaian"],
    queryFn: getListBobotKomponenPenilaian,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
